import { useFeatureIsOn as useFeatureFlagIsOn } from '@growthbook/growthbook-react';

import type { AppFeature } from '../types';

const useFeatureIsOn = (key: AppFeature): boolean => {
  return useFeatureFlagIsOn(key);
};

export { useFeatureIsOn };
